import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import { numberWithCommas } from "modules/functions";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";

import adPlanIcon from "assets/img/icons/icons8-web-advertising.svg";
import bronzeCheckmarkIcon from "assets/img/icons/checkmark-bronze.svg";
import silverCheckmarkIcon from "assets/img/icons/checkmark-silver.svg";
import goldCheckmarkIcon from "assets/img/icons/checkmark-gold.svg";
import coinsIcon from "assets/img/icons/coins-icon.svg";
import newTabIcon from "assets/img/icons/Expand-Window.svg";

const AdPlanOverview = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const TitleIcon = styled.div`
  display: inline-block;
  padding-right: 5px;

  transform: translateY(4.5px);

  width: 26px;
  min-width: 26px;
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DataTitle = styled.div`
  font-weight: 500;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const DataRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const DataIconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataIcon = styled.div`
  width: ${(props) => (props.width ? props.width : "20px")};
  min-width: ${(props) => (props.width ? props.width : "20px")};
  height: ${(props) => (props.width ? props.width : "20px")};
`;

const DataText = styled.div`
  white-space: nowrap;

  display: flex;
  align-items: center;
  gap: 3px;
`;

const SelectPlanLink = styled(Link)`
  text-decoration: none;

  display: flex;
  align-items: center;
  gap: 3px;
`;

const SelectPlanLinkText = styled.div`
  color: ${css.LIGHT_BLUE};
  font-weight: 400;
  text-decoration: none;
`;

const NewTabIcon = styled.div`
  padding-top: 2px;

  width: 11px;
  min-width: 11px;

  transform: translateY(1px);
`;

const ButtonWrap = styled.div`
  display: flex;
`;

export default ({ plan }) => {
  const navigate = useNavigate();

  let planIcon;
  let planName;
  let planMonthlyCoins;

  switch (plan) {
    case 1:
      planIcon = bronzeCheckmarkIcon;
      planName = "Bronze";
      planMonthlyCoins = 2500;
      break;
    case 2:
      planIcon = silverCheckmarkIcon;
      planName = "Silver";
      planMonthlyCoins = 10000;
      break;
    case 3:
      planIcon = goldCheckmarkIcon;
      planName = "Gold 20";
      planMonthlyCoins = 20000;
      break;
    case 4:
      planIcon = goldCheckmarkIcon;
      planName = "Gold 40";
      planMonthlyCoins = 40000;
      break;
    case 5:
      planIcon = goldCheckmarkIcon;
      planName = "Gold 60";
      planMonthlyCoins = 60000;
      break;
    case 6:
      planIcon = goldCheckmarkIcon;
      planName = "Gold 80";
      planMonthlyCoins = 80000;
      break;
    case 7:
      planIcon = goldCheckmarkIcon;
      planName = "Gold 100";
      planMonthlyCoins = 100000;
      break;
  }

  return (
    <AdPlanOverview>
      <BoxTitle>
        <TitleIcon>
          <img src={adPlanIcon} style={{ width: "100%" }} />
        </TitleIcon>
        Your Ad Plan
      </BoxTitle>
      <Data>
        <DataTitle>Active Plan</DataTitle>
        <DataRow>
          <DataIconBox>
            <DataIcon>
              <img src={planIcon} style={{ width: "100%" }} />
            </DataIcon>
          </DataIconBox>
          <DataText>{planName}</DataText>
        </DataRow>
      </Data>
      <Data>
        <DataRow>
          <DataIconBox>
            <DataIcon>
              <img src={coinsIcon} style={{ width: "100%" }} />
            </DataIcon>
          </DataIconBox>
          <DataText>
            {numberWithCommas(planMonthlyCoins)} Coins daily and{" "}
            <SelectPlanLink
              to="https://help.scalelup.com/en/articles/10962832-detailed-overview-of-scalelup-advertising-plan-features"
              target="_blank"
            >
              <SelectPlanLinkText>other features</SelectPlanLinkText>
              <NewTabIcon>
                <img src={newTabIcon} style={{ width: "100%" }} />
              </NewTabIcon>
            </SelectPlanLink>
          </DataText>
        </DataRow>
      </Data>
      <ButtonWrap>
        <ButtonPrimarySmall onClick={() => navigate("/manage-ad-plan")}>
          Manage Plan Subscription
        </ButtonPrimarySmall>
      </ButtonWrap>
    </AdPlanOverview>
  );
};
